import { render, staticRenderFns } from "./CancelEmployeeInTour.vue?vue&type=template&id=2fa520c1&scoped=true"
import script from "./CancelEmployeeInTour.vue?vue&type=script&lang=js"
export * from "./CancelEmployeeInTour.vue?vue&type=script&lang=js"
import style0 from "./CancelEmployeeInTour.vue?vue&type=style&index=0&id=2fa520c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa520c1",
  null
  
)

export default component.exports